/**
 * Split Variant Picker — replaces a single Shopify variant dropdown with
 * two dependent dropdowns (Scale → Key) when variants contain both
 * "Major" and "Minor" in their titles.
 *
 * Re-initializes after variant:update (theme morph) to survive DOM changes.
 */
(function () {
  function init() {
    // Don't double-init
    if (document.querySelector('.tt-split-picker')) return;

    var nativeSelect = document.querySelector('variant-picker select');
    if (!nativeSelect) return;

    var options = Array.from(nativeSelect.options);

    // Only activate if variants contain both Major and Minor
    var hasMajor = options.some(function (o) { return o.text.includes('Major'); });
    var hasMinor = options.some(function (o) { return o.text.includes('Minor'); });
    if (!hasMajor || !hasMinor) return;

    // Group options by scale
    var groups = {};
    options.forEach(function (o) {
      var scale, key;
      if (o.text.includes('Minor')) {
        scale = 'Minor';
        key = o.text.replace('Minor', '').replace(/[()]/g, '').trim();
      } else {
        scale = 'Major';
        key = o.text.replace('Major', '').replace(/[()]/g, '').trim();
      }
      if (!key) key = o.text;
      if (!groups[scale]) groups[scale] = [];
      groups[scale].push({ key: key, value: o.value, text: o.text });
    });

    // Hide native fieldset
    var fieldset = nativeSelect.closest('fieldset') || nativeSelect.parentElement;
    fieldset.style.display = 'none';

    // Create container
    var container = document.createElement('div');
    container.className = 'tt-split-picker';
    container.style.cssText = 'display:flex;flex-direction:column;gap:12px;';

    // Scale dropdown
    var scaleLabel = document.createElement('label');
    scaleLabel.textContent = 'Scale';
    scaleLabel.style.cssText = 'font-size:0.85em;font-weight:600;margin-bottom:2px;';
    var scaleSelect = document.createElement('select');
    scaleSelect.className = nativeSelect.className;
    Object.keys(groups).forEach(function (s) {
      var opt = document.createElement('option');
      opt.value = s;
      opt.textContent = s;
      scaleSelect.appendChild(opt);
    });

    // Key dropdown
    var keyLabel = document.createElement('label');
    keyLabel.textContent = 'Key';
    keyLabel.style.cssText = 'font-size:0.85em;font-weight:600;margin-bottom:2px;';
    var keySelect = document.createElement('select');
    keySelect.className = nativeSelect.className;

    function populateKeys(scale) {
      keySelect.innerHTML = '';
      var items = groups[scale] || [];
      items.forEach(function (item) {
        var opt = document.createElement('option');
        opt.value = item.value;
        opt.textContent = item.key || scale;
        keySelect.appendChild(opt);
      });
    }

    function syncNative() {
      var val = keySelect.value;
      if (nativeSelect.value !== val) {
        nativeSelect.value = val;
        nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // Detect current selection
    var currentOption = nativeSelect.options[nativeSelect.selectedIndex];
    var currentScale = currentOption && currentOption.text.includes('Minor') ? 'Minor' : 'Major';
    scaleSelect.value = currentScale;
    populateKeys(currentScale);
    if (currentOption) keySelect.value = currentOption.value;

    scaleSelect.addEventListener('change', function () {
      populateKeys(scaleSelect.value);
      syncNative();
    });

    keySelect.addEventListener('change', function () {
      syncNative();
    });

    // Build DOM
    var scaleWrap = document.createElement('div');
    scaleWrap.appendChild(scaleLabel);
    scaleWrap.appendChild(scaleSelect);

    var keyWrap = document.createElement('div');
    keyWrap.appendChild(keyLabel);
    keyWrap.appendChild(keySelect);

    container.appendChild(scaleWrap);
    container.appendChild(keyWrap);

    fieldset.parentElement.insertBefore(container, fieldset);
  }

  // Initial run
  setTimeout(init, 500);

  // Re-init after variant morph
  document.addEventListener('variant:update', function () {
    setTimeout(function () {
      // Remove old split picker (morph may have restored native)
      var old = document.querySelector('.tt-split-picker');
      if (old) old.remove();
      init();
    }, 300);
  });
})();
